<template>
  <div class="page">
    <template v-if="loading">
      <v-row>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-row>
      <v-row class="mt-4">
        {{ $t("projects.project.loading") }}
      </v-row>
    </template>
    <template v-if="!loading && project">
      <!--      <h2 class="text-h2 mb-3">-->
      <!--        {{ project.project_name }}-->
      <!--        &lt;!&ndash;        <span class="text-overline ml-2">{{ project.status }}</span>&ndash;&gt;-->
      <!--      </h2>-->

      <v-tabs v-model="tab">
        <v-tab>
          {{ $t("projects.project.general") }}
        </v-tab>
        <v-tab>
          {{ $t("projects.project.slideManagement") }}
        </v-tab>
        <v-tab>
          {{ $t("projects.project.annotationClasses") }}
        </v-tab>
        <!--        <v-tab>Annotation validation</v-tab>-->
        <v-tab>
          {{ $t("projects.project.userManagement") }}
        </v-tab>
        <v-tab>
          {{ $t("projects.project.extractedROIs") }}
        </v-tab>
        <v-tab>
          {{ $t("projects.project.kappaCoefficient") }}
        </v-tab>
      </v-tabs>
      <v-tabs-items :value="tab" class="mt-3">
        <v-tab-item>
          <general :project="project"></general>
        </v-tab-item>
        <v-tab-item>
          <slide-management :project="project"></slide-management>
        </v-tab-item>
        <v-tab-item>
          <annotation-classes :project="project"></annotation-classes>
        </v-tab-item>
        <!--        <v-tab-item>-->
        <!--          <AnnotationValidation :project="project"></AnnotationValidation>-->
        <!--        </v-tab-item>-->
        <v-tab-item>
          <user-management :project="project"></user-management>
        </v-tab-item>
        <v-tab-item>
          <RoiExtraction :project="project"></RoiExtraction>
        </v-tab-item>
        <v-tab-item>
          <KappaMetric :project="project"></KappaMetric>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import General from "@/components/projects/General";
import UserManagement from "@/components/projects/user-management/List";
import AnnotationClasses from "@/components/projects/annotation-class/List";
import SlideManagement from "@/components/projects/SlideManagement";
import RoiExtraction from "@/components/projects/RoiExtraction";
import KappaMetric from "@/components/projects/KappaMetric";
import { ACTION_SET_CURRENT_PROJECT } from "@/store/modules/project";

export default {
  data: () => ({
    tab: 0,
    loading: true
  }),
  computed: {
    ...mapState({
      token: state => state.authentication.keycloak.token,
      project: state => state.project.currentProject
    })
  },
  watch: {
    tab(val) {
      // avoid duplicated route exception
      if (+val !== +this.$route.query.t)
        this.$router.replace({ query: { t: val } });
    }
  },
  mounted() {
    this.loading = true;
    // if direct entry and project is not loaded yet, redirect to list page for now
    if (this.project === null) {
      this.$store.dispatch(ACTION_SET_CURRENT_PROJECT, {
        id: this.$route.params.id
      });
    }
    // set tab from query
    this.tab = +this.$route.query.t;
    this.loading = false;
  },
  components: {
    RoiExtraction,
    General,
    UserManagement,
    KappaMetric,
    AnnotationClasses,
    SlideManagement
  }
};
</script>

<style scoped></style>
